"use client";
import { useContext, useEffect, useRef, useState } from "react";
import { useRouter } from "next/navigation";
import { Container, Skeleton, Text } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { LayoutProps } from "@/components/layout/layoutType";
import { AlertContext } from "@/components/context/alertContext";

import Icon from "@/components/common/icon/sicon";
import Link from "next/link";
import { Button, Flex, Input, InputRef } from "antd";
import { Debug } from "@/util/debug";
import { alertClose, setTimeoutDelay } from "../layout/list/defaultType";
import { appRouterPush } from "@/util/apputil";
import IntroLink from "./introLink";
//import dynamic from "next/dynamic";
//const SIcon = dynamic(() => import("@/components/common/icon/sicon"), { ssr: false });

const sample_link = process.env.NEXT_PUBLIC_LINK_SAMPLE_BEAN ?? "https://coffeein.site/info/brewing/note/EfDXzSB8F2O2gAqaR9Il8Q";
export default function CoffeeBeanIntro({ params }: { params?: LayoutProps }) {
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Container size="1" className=" mt-16 lg:mt-32 text-center">
      <Skeleton loading={loading}>
        <Icon
          iconType="phosphor"
          iconName="CoffeeBean"
          className={"size-48 inline-block group animate-infinite animate-pulse animate-none-"}
          weight="duotone"
          size={48}
        />
      </Skeleton>
      <IntroLink {...params} intro_text="coffeebean_intro" sample_link={sample_link} />
    </Container>
  );
}
